export default __webpack_public_path__ + "static/media/Notification.7ff3f798.svg";